import { render, staticRenderFns } from "./IntroPen3.vue?vue&type=template&id=1bbfc6ac&scoped=true&"
import script from "./IntroPen3.vue?vue&type=script&lang=js&"
export * from "./IntroPen3.vue?vue&type=script&lang=js&"
import style0 from "./IntroPen3.vue?vue&type=style&index=0&id=1bbfc6ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfc6ac",
  null
  
)

export default component.exports